module.exports = __webpack_public_path__ + "img/cww_12.73d8417f.jpg";